import { render, staticRenderFns } from "./RoundIcon.vue?vue&type=template&id=545aee10"
import script from "./RoundIcon.vue?vue&type=script&lang=js"
export * from "./RoundIcon.vue?vue&type=script&lang=js"
import style0 from "./RoundIcon.vue?vue&type=style&index=0&id=545aee10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports